module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13.223' height='8.574' viewBox='0 0 13.223 8.574'%3E %3Cdefs%3E %3Cstyle%3E .cls-1 %7B fill: %23f77629; %7D %3C/style%3E %3C/defs%3E %3Cpath id='Shape_1' data-name='Shape 1' class='cls-1' d='M1765.093,70.4l1.358-1.168,5.075,5.44,5.4-5.736,1.386,1.319-6.6,7.255Z' transform='translate(-1765.093 -68.937)'/%3E %3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow_down.svg
// module id = 943
// module chunks = 0